import {LOAD_DATA, SUCCESS, STORE} from "../../../constants";

const defaultSeo = {
  adminTagNames: '',
  afterMenuText: '',
  bannerImageUrl: '',
  beforeFooterText: '',
  h1Text: '',
  h2Text: '',
  htmlTitle: '',
  regularText: '',
  faq: [],
  ourAdvantages: [],
  breadcrumbs: [],
  advantages: [],
  tabsBlock: []
};

export default (seo = defaultSeo, action) => {
  const {type, response} = action;

  switch (type) {
    case STORE + LOAD_DATA + SUCCESS:
      return response.seo;
  }

  return seo;
};
